import Typography from '@mui/material/Typography';
import Box from '@mui/system/Box';
import { GradientIcon } from 'src/components/gradients/GradientIcon';
import theme from 'src/styles/theme';
import { LoginMethods, LoginMethodType } from './LoginMethods';

type LoginOptionType = {
  loginMethodType: LoginMethodType;
  signInFn: (loginMethodType: LoginMethodType) => void;
};

export function LoginOption({ loginMethodType, signInFn }: LoginOptionType) {
  if (!loginMethodType) return null;

  const loginMethodData = LoginMethods[`${loginMethodType}`];
  const loginIcon = loginMethodData.icon;

  return (
    <Box
      display={'flex'}
      flexDirection={'row'}
      alignItems={'center'}
      padding={'16px 14px'}
      borderRadius={'4px'}
      sx={{
        background: theme.palette.other.textSecondaryShades.opacity8,
        cursor: 'pointer',
      }}
      onClick={() => {
        signInFn(loginMethodType);
      }}
    >
      <Box mr={'26px'} lineHeight={'0'}>
        <GradientIcon
          IconComponent={loginIcon}
          gradientColor="primary.horizontal"
        />
      </Box>
      <Box>
        <Typography variant="body1" textTransform={'uppercase'}>
          {!!loginMethodData.continueWithMessage
            ? loginMethodData.continueWithMessage
            : `Continue with ${loginMethodType}`}
        </Typography>
      </Box>
    </Box>
  );
}
